<template>
  <img
    v-if="$whitelabel === 'digifarm'"
    src="@/assets/digifarm-logo.png"
    alt="logo"
    class="logo digifarm"
    draggable="false"
  />
  <img 
    v-else
    class="logo" 
    draggable="false" 
    src="@/assets/logo-full.png" 
    alt="logo"
  />
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.logo {
  width: 400px;
  height: auto;
  margin-bottom: 24px;
  margin-top: 20px;

  &.digifarm {
    max-width: 200px;
  }
}

</style>